<template>
<div>
  <v-row no-gutters justify="end" class="pt-1" style="height: 32px">
    <dd-transparent-button
      v-if="isUseGuide"
      :minWidth="140"
      color="green"
      @click="onClickUseGuideClick"
    >
      <v-icon color="green">mdi-help-box</v-icon>
      <span class="v-btn-icon-tutorial">操作ガイドを表示</span>
    </dd-transparent-button>
  </v-row>
  <v-card class="ma-1 px-5 base-area">
    <v-card-text>
      <v-row no-gutters class="px-1 pt-3 pb-0">
        <div style="display: inline-block;">
          <span class="view-title" id="v-step-0">{{ viewTitle }}</span>
          <!-- 位置調整用 -->
        </div>
        <div style="display: inline-block;padding-top:2px" class="mr-2">
          <dd-icon-button-with-tooltip
            v-if="isUseGuide"
            addClass="d-none d-sm-block"
            color="green"
            message="操作ガイドを表示します"
            icon="mdi-help-box"
            @click="onClickUseGuideClick"
          />
        </div>
        <div style="padding-top:2px">
          <dd-custom-button
            v-if="isShowCreateButton"
            :disabled="isDisableCreateButton"
            :rounded="true"
            :minWidth="60"
            :small="true"
            @click="onCreateButtonClick"
          >
            {{ functionName }}を新規追加する
          </dd-custom-button>
        </div>
      </v-row>

      <hr class="section-line">

      <!-- **************************************************************************************************** --
        -- 検索条件
        -- **************************************************************************************************** -->
      <div class="pa-2">
        <v-row no-gutters>
          <v-col :cols="12">
            <v-row no-gutters justify="start" id="starndardWidth">
              <dd-sub-header>
                <span v-if="isConditionHide && ![undefined, null].includes(conditionDetails)">指定している検索条件</span>
                <span v-else>以下の検索条件で絞り込む</span>
                <span class="d-flex" style="float: right;">
                  <div>
                    <dd-transparent-button
                      v-if="isConditionHide"
                      :rounded="true"
                      :minWidth="100"
                      @click="onSearchButtonClick">
                      <v-icon>mdi-magnify</v-icon>
                      検索をする
                    </dd-transparent-button>
                  </div>
                  <div>
                    <dd-transparent-button :minWidth="140" @click="isConditionHide = !isConditionHide">
                      <div v-if="!isConditionHide" class="condition-expansion">検索条件を閉じる<v-icon>mdi-chevron-up</v-icon></div>
                      <div v-else class="condition-expansion">検索条件を開く<v-icon>mdi-chevron-down</v-icon></div>
                    </dd-transparent-button>
                  </div>
                </span>
              </dd-sub-header>
            </v-row>
            <div v-if="!isConditionHide" class="px-1 pt-0 pb-2 condition-area">
              <v-row no-gutters v-if="isShowHeaderDescription">
                <v-col :cols="12" v-if="headerDescription === null">
                  <span class="ml-1 view-description">登録済み{{functionName}}を検索したい条件を入力して[検索をする]を押下してください。
                  <span v-if="isShowCreateButton">新規に{{functionName}}を追加する場合は[{{ functionName }}を新規追加する]ボタンを押下してください。</span></span>
                </v-col>
                <v-col :cols="12" v-else>
                  <span>{{ headerDescription }}</span>
                </v-col>
              </v-row>
              <slot>
              <!-- 任意設定エリア -->
              </slot>
              <v-row class="mt-2" no-gutters justify="center">
                <dd-custom-button
                  :rounded="true"
                  :minWidth="200"
                  :large="true"
                  :tooltipText="`入力された検索条件で登録済み${functionName}を検索します`"
                  :enableToolTip="helpUseFlg"
                  :tooltipBottom="true"
                  @click="onSearchButtonClick">
                  検索をする
                </dd-custom-button>
                <a
                  class="condition-clear"
                  @click="onClearButtonClick">
                  条件をクリア
                </a>
              </v-row>
            </div>
            <div class="px-1 py-2 condition-area" v-show="isConditionHide && ![undefined, null].includes(conditionDetails)">
              <v-row no-gutters v-if="isConditionChange">
                <v-icon class="mx-1" color="green" small>mdi-information-outline</v-icon>
                <span style="font-size:0.8rem;color:green;">条件が変更されました。「検索をする」で再読み込みしてください。</span>
              </v-row>
              <v-row no-gutters>
                <span style="display: inline-block">
                  <span v-for="item in conditionDetails" :key="item.key">
                    <v-chip class="mx-1" color="#4169e1" small dark :close="item.delete" v-if="item.type !== 'checkbox' && ![undefined, null, ''].includes(conditions[item.key]) || (item.type === 'checkbox' && conditions[item.key] === true)" @dblclick="isConditionHide = false" @click:close="onRemoveConditionClick(item.key, item.type)">
                      <!--
                      <span>{{item.name}}：</span><span style="color:greenyellow">{{ conditions[item.value] }}</span>
                      -->
                      <span>{{ getItemName(item) }}</span><span style="color:greenyellow;white-space: pre-wrap;">{{ getItemValue(item) }}</span>
                    </v-chip>
                  </span>
                </span>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- **************************************************************************************************** --
        -- 検索結果
        -- **************************************************************************************************** -->
      <div class="px-1 pt-1 pb-4" v-if="items.length > 0">
        <v-row no-gutters>
          <v-col :xs="6" :sm="6" :md="6" :lg="2" :xl="2" :cols="6" class="px-1">
            <v-row no-gutters>
              <span class="search-number">{{ items.length }}</span><span class="mt-2 text-black">件 の検索結果</span>
              <div class="mt-2" v-if="![undefined, null, ''].includes(vSearchText)">
                <span span class="filter-row-text">（</span>
                <span class="filter-number">{{ filteredRowCount }}</span>
                <span span class="filter-row-text">件 表示中）</span>
              </div>
            </v-row>
          </v-col>
          <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7" v-if="isShowCsvDownload || isShowXlsDownload">
            <span v-if="isShowCsvDownload">
              <dd-custom-button
                :loading="isCsvDownloader"
                :disabled="isOutputButtonDisabled"
                tooltipText="一覧をCSVファイル形式でダウンロードします"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
                @click="onCsvButtonClick">
                CSVで出力
                <template v-slot:loader>
                  <span>出力中...</span>
                </template>
              </dd-custom-button>
            </span>
            <span v-if="isShowXlsDownload">
              <dd-custom-button
                :loading="isXlsDownloader"
                :disabled="isOutputButtonDisabled"
                tooltipText="一覧をXLSファイル形式でダウンロードします"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
                @click="onXlsButtonClick">
                EXCELで出力
                <template v-slot:loader>
                  <span>出力中...</span>
                </template>
              </dd-custom-button>
            </span>
            <a id="csvdownload" href="#" style="display:none;">ダウンロード</a>
            <a id="xlsdownload" href="#" style="display:none;">ダウンロード</a>
            <span class="ml-2">
              <slot name="custom-button" />
            </span>
          </v-col>
          <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2" v-if="!abbreviatedDisplay">
            <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
          </v-col>
          <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
            <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="vSearchText"/>
          </v-col>
        </v-row>

        <hr class="section-line mb-2">

        <!-- スクロールでの固定表示用 -->
        <div id="sticky-hidden" class="sticky-hidden px-1" v-show="isShowStickyHeader">
          <div id="sticky-hidden-div" class="sticky-hidden-div"></div>
          <div id="sticky-hidden-scroll" class="sticky-hidden-scroll" v-show="isScrollX && isHeaderScroll">
            <div id="hiddenbar" class="design-scroll scroll-x-bar" v-scroll.self="onScrollXBar">
              <div class="inner-topbar"></div>
            </div>
          </div>
        </div>

        <v-row no-gutters>
          <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
            <div v-if="isBatchCommand">
              <v-row no-gutters>
                <v-col :cols="4" class="px-1">
                  <dd-drop-down
                    value="一括操作"
                    :items="['一括操作', '削除']"
                  />
                </v-col>
                <v-col :cols="2" class="mt-1">
                  <dd-custom-button
                    :rounded="true"
                    :minWidth="60"
                    :small="true"
                    @click="onDummyFunction"
                  >
                    適用
                  </dd-custom-button>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" v-show="!abbreviatedDisplay">
            <dd-select-items-per-page
              ref="pagination1"
              :itemsPerPage.sync="vitemsPerPage"
              :currentPage.sync="vPage"
              :items="items"
              @changeItemsPerPage="changeItemsPerPage"
              @changePage="changePage"
            />
          </v-col>
        </v-row>

        <v-row no-gutters class="mt-2">
          <v-col :cols="12" class="px-1">
            <div id="dt-area" class="dt-area">
              <v-data-table
                id="searchResult"
                :item-key="itemKey"
                :headers="itemHeaders"
                :items="displayItems"
                v-model="selected"
                :search="vSearchText"
                :custom-filter="filtering"
                :items-per-page.sync="vitemsPerPage"
                :page.sync="vPage"
                @dblclick:row="onRowDoubleClick"
                no-data-text="対象データはありません"
                :show-select="isShowSelect"
                fixed-header
                :hide-default-header="abbreviatedDisplay"
                hide-default-footer
                locale="ja-jp"
                class="auto-row-height"
                dense
              >
                <template v-slot:header>
                  <tr>
                    <th :colspan="itemHeaders.length" class="sticky-scroll" v-show="isScrollX && isHeaderScroll">
                      <div id="topbar" class="design-scroll scroll-x-bar" v-scroll.self="onScrollXBar">
                        <div class="inner-topbar"></div>
                      </div>
                    </th>
                  </tr>
                </template>
                <template v-slot:[`item.actions`]="{item}">
                  <template>
                    <dd-icon-button-with-tooltip
                      message="この行を編集します"
                      icon="mdi-pencil-circle"
                      @click="onRowEditButtonClick(item)"
                    />
                  </template>
                </template>
                <template v-slot:[`item.detailref`]="{item}">
                  <template>
                    <dd-icon-button-with-tooltip
                      message="この行の詳細を表示します"
                      icon="mdi-text-box-search-outline"
                      @click="onRowDetailButtonClick(item)"
                    />
                  </template>
                </template>
                <template v-slot:[`item.detailrefchip`]="{item}">
                  <template>
                    <v-chip
                      small
                      color="primary"
                      text-color="white"
                      @click="onRowDetailButtonClick(item)"
                    >
                      詳細
                    </v-chip>
                  </template>
                </template>
                <template v-if="$scopedSlots.body" v-slot:body="slotProps">
                  <slot name="body" :displayItems="displayItems" :headers="slotProps.headers">
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in displayItems"
                        :key="getRowKey(row, rowIndex)"
                      >
                        <td v-for="h in slotProps.headers" :key="h.value">
                          {{ row[h.value] }}
                        </td>
                      </tr>
                    </tbody>
                  </slot>
                </template>
                <template slot="footer">
                  <tr>
                    <th :colspan="itemHeaders.length" v-if="isScrollX">
                      <div id="footbar" class="design-scroll scroll-x-bar" v-scroll.self="onScrollXBar">
                        <div class="inner-topbar"></div>
                      </div>
                    </th>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-else class="pb-2" />
    </v-card-text>
  </v-card>

  <div class="pa-2" v-if="items.length > 0">
    <v-row no-gutters>
      <v-col :xs="12" :sm="12" :md="2" :lg="2" :xl="2" :cols="12" class="px-1">
        <span class="search-number">{{ rowNumber }}</span>件 の検索結果
      </v-col>
      <v-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :cols="12">
        <span v-if="isShowCsvDownload">
          <dd-custom-button
            :loading="isCsvDownloader"
            :disabled="isOutputButtonDisabled"
            tooltipText="一覧をCSVファイル形式でダウンロードします"
            :tooltipTop="true"
            :enableToolTip="helpUseFlg"
            @click="onCsvButtonClick">
            CSVで出力
            <template v-slot:loader>
              <span>出力中...</span>
            </template>
          </dd-custom-button>
        </span>
        <span v-if="isShowXlsDownload">
          <dd-custom-button
            :loading="isXlsDownloader"
            :disabled="isOutputButtonDisabled"
            tooltipText="一覧をXLSファイル形式でダウンロードします"
            :tooltipTop="true"
            :enableToolTip="helpUseFlg"
            @click="onXlsButtonClick">
            EXCELで出力
            <template v-slot:loader>
              <span>出力中...</span>
            </template>
          </dd-custom-button>
        </span>
        <template v-if="$scopedSlots['custom-button']">
          <span class="ml-2">
            <slot name="custom-button" />
          </span>
        </template>
      </v-col>
      <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" class="px-1">
        <v-row no-gutters justify="end">
          <div v-if="isShowCreateButton">
            <dd-custom-button
              :rounded="true"
              :minWidth="200"
              @click="onCreateButtonClick"
            >
              {{ functionName }}を新規追加する
            </dd-custom-button>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-1" v-show="!abbreviatedDisplay">
      <v-col :cols="6" class="d-sm-block" />
      <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" class="px-1">
        <dd-select-items-per-page
          ref="pagination2"
          :itemsPerPage.sync="vitemsPerPage"
          :currentPage.sync="vPage"
          :items="items"
          @changeItemsPerPage="changeItemsPerPage"
          @changePage="changePage"
        />
      </v-col>
    </v-row>
  </div>

</div>
</template>

<script>
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'

const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'DdSearchList',
  mixins: [flowMixin],
  props: {
    // 画面タイトル
    viewTitle: String,
    /**
     * 機能名
     */
    functionName: String,
    /**
     * 追加ボタン表示
     */
    isShowCreateButton: {
      type: Boolean,
      default: true
    },
    /**
     * 追加ボタン使用不可
     */
    isDisableCreateButton: {
      type: Boolean,
      default: false
    },
    /**
     * データテーブル用ヘッダ
     */
    itemHeaders: Array,
    /**
     * データテーブル用データ
     */
    items: Array,
    /**
     * データテーブルキー
     */
    itemKey: String,
    /**
     * 検索条件
     */
    conditions: Object,
    /**
     * 検索条件簡易表示用
     */
    conditionDetails: Array,
    /**
     * ページ
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 1ページ当たりの行数
     */
    itemsPerPage: {
      type: Number,
      default: 100
    },
    /**
     * 検索結果件数
     */
    rowNumber: Number,
    /**
     * チェックボックス表示時有無
     */
    isShowSelect: {
      type: Boolean,
      default: true
    },
    /**
     * 一括操作ボタン表示有無
     */
    isBatchCommand: {
      type: Boolean,
      default: true
    },
    /**
     * CSV出力ボタン表有無（DEFAULT:TRUE)
     */
    isShowCsvDownload: {
      type: Boolean,
      default: true
    },
    /**
     * CSV出力用props
     */
    csvFunction: String,
    csvConditions: Object,
    csvFileName: String,
    /**
     * Xls出力用props
     */
    xlsFunction: String,
    xlsConditions: Object,
    xlsFileName: String,
    /**
     * XLS出力ボタン表示有無（DEFAULT:FALSE)
     */
    isShowXlsDownload: {
      type: Boolean,
      default: false
    },
    /**
     * 選択状態
     */
    selected: Array,
    /**
     * 検索後条件非表示
     */
    isConditionHideAfterSearch: {
      type: Boolean,
      default: false
    },
    /**
     * 説明文
     */
    isShowHeaderDescription: {
      type: Boolean,
      default: true
    },
    headerDescription: {
      type: String,
      default: null
    },
    isUseGuide: {
      type: Boolean,
      default: false
    },
    initSearchText: {
      type: String,
      default: ''
    },
    APIReceiveCsvLayoutKbn: {
      type: String,
      default: ''
    },
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdSubHeader
  },
  data: () => ({
    // 画面情報
    isShowStickyHeader: false,
    isCreateStickyHeader: false,
    screenWidth: null,
    tableWidth: null,
    scrollAddress: 0,
    // 条件制御用
    isConditionHide: false,
    // 条件変更
    isConditionChange: false,
    // 一覧制御用
    isCsvDownloader: false,
    isXlsDownloader: false,
    // ページネーション用
    vitemsPerPage: 0,
    vPage: 1,
    vSearchText: ''
  }),
  computed: {
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      currentKaishaCode: 'users/currentKaishaCode',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredRowCount () {
      const items = this.itemHeaders.map(h => h.value)
      const text = this.vSearchText
      const length = this.items.filter(r => {
        for (let i = 0; i < items.length; i++) {
          const hit = this.filtering(r[items[i]], text, r)
          if (hit) { return true }
        }
        return false
      }).length
      return length
    },
    isScrollX () {
      if (![undefined, null, 0].includes(this.screenWidth) && ![undefined, null, 0].includes(this.tableWidth) && this.items.length > 0) {
        return this.screenWidth < this.tableWidth
      } else {
        return false
      }
    },
    isHeaderScroll () {
      return ((this.items) && this.items.length > 10)
    },
    isOutputButtonDisabled () {
      return this.items.length === 0
    },
    displayItems () {
      const text = this.vSearchText
      if (!text) return this.items

      // itemHeaders の value を対象に filtering を適用
      const keys = (this.itemHeaders || []).map(h => h.value).filter(Boolean)

      return (this.items || []).filter(row => {
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (this.filtering(row[key], text, row)) return true
        }
        return false
      })
    }
  },
  watch: {
    page: function (newVal) {
      const self = this
      self.vPage = newVal
    },
    vPage: function (newVal) {
      const self = this
      self.$nextTick().then(() => {
        // ページングと同時にhiddenヘッダー更新
        self.isCreateStickyHeader = false
        self.createStickyHeader()
        self.$emit('update:page', newVal)
      })
    },
    itemsPerPage: function (newVal) {
      const self = this
      self.vitemsPerPage = newVal
    },
    vitemsPerPage: function (newVal) {
      const self = this
      self.$emit('update:itemsPerPage', newVal)
    },
    initSearchText: function (newVal) {
      const self = this
      self.vSearchText = newVal
    },
    vSearchText: function (newVal) {
      const self = this
      self.$emit('update:searchText', newVal)
    }
  },
  created () {
  },
  mounted () {
    // スクロールイベント付与
    window.addEventListener('scroll', this.scrollEvent)
  },
  methods: {
    onResize (p) {
      this.setTableWidth()
    },
    scrollEvent: function (e) {
      const self = this
      const se = document.getElementById('dt-area')
      if (se) {
        console.log('scrollEvent', se.getBoundingClientRect().top)
        if (!this.isCreateStickyHeader) {
          this.createStickyHeader()
        }
        if (se.getBoundingClientRect().top < 35) {
          this.$nextTick(() => {
            self.isShowStickyHeader = true
          })
        } else {
          this.$nextTick(() => {
            self.isShowStickyHeader = false
          })
        }
      }
    },
    setTableWidth: function () {
      // CSS変数設定
      const dw = document.getElementById('starndardWidth')
      if ([undefined, null].includes(dw)) { return }
      document.documentElement.style.setProperty('--div-width', dw.clientWidth + 'px')
      document.documentElement.style.setProperty('--table-width', dw.clientWidth + 'px')

      this.screenWidth = dw.clientWidth
      // this.tableWidth = dw.clientWidth

      // テーブル幅再設定
      const sr = document.getElementById('searchResult')
      if (sr) {
        const tw = sr.getElementsByClassName('v-data-table-header')
        if (tw.length > 0) {
          document.documentElement.style.setProperty('--table-width', tw[0].clientWidth + 'px')
          this.tableWidth = tw[0].clientWidth
        }
      }
      if (this.screenWidth !== dw.clientWidth || this.tableWidth === null) {
        this.settingScrollPosition(this.scrollAddress)
      }
    },
    onScrollXBar: function (e) {
      console.log('onScrollXBar 1', e.target.scrollLeft)
      // スクロール現在位置更新
      this.scrollAddress = e.target.scrollLeft
      const tw = document.getElementById('searchResult')
      var w = tw.getElementsByClassName('v-data-table__wrapper')
      if (w.length > 0) {
        w[0].scrollLeft = this.scrollAddress
      }
      this.settingScrollPosition(this.scrollAddress)
    },
    settingScrollPosition: function (pos) {
      const baseElement = document.getElementById('searchResult')
      if (!baseElement) { return false }
      const baseTable = baseElement.querySelector('table')

      var elem1 = document.getElementById('sticky-hidden-div')
      if (elem1) elem1.scrollTo(pos, 0)
      var elem2 = document.getElementById('hiddenbar')
      if (elem2) elem2.scrollTo(pos, 0)
      var elem3 = baseTable.querySelector('#topbar')
      if (elem3) elem3.scrollTo(pos, 0)
      var elem4 = baseElement.querySelector('#footbar')
      if (elem4) elem4.scrollTo(pos, 0)
      var elem5 = baseTable.querySelector('.v-data-table-header')
      if (elem5) elem5.scrollTo(pos, 0)
    },
    // stickyヘッダー作成
    createStickyHeader: function () {
      this.$nextTick().then(() => {
        // ベース情報取得
        const baseElement = document.getElementById('searchResult')
        if (!baseElement) return

        const baseTable = baseElement.querySelector('thead')
        if (!baseTable) return

        const baseTr = baseTable.getElementsByTagName('tr')[0]?.cells
        if (!baseTr) return

        // Sticky SPAN
        const sdiv = document.getElementById('sticky-hidden-div')
        if (sdiv) {
          while (sdiv.lastChild) {
            sdiv.removeChild(sdiv.lastChild)
          }
        }

        for (var x = 0; x < baseTr.length; x++) {
          console.log('createStickyHeader span', x, baseTr[x].offsetWidth)
          const vclass = x === 0 ? 'sticky-hidden-div-span span-sticky-col1' : 'sticky-hidden-div-span'
          sdiv.innerHTML += `<span class="${vclass}" style="display:inline-block;width:${baseTr[x].offsetWidth}px">${baseTr[x].innerHTML}</span>`
        }

        this.isCreateStickyHeader = true
      })
    },

    // ボタン操作
    onClickUseGuideClick: function () {
      this.$emit('guideOn')
    },
    onCreateButtonClick: function () {
      this.$emit('create')
    },
    onSearchButtonClick: function () {
      this.scrollAddress = 0
      this.isCreateStickyHeader = false
      this.$emit('search')
      if (this.isConditionHideAfterSearch) {
        this.isConditionChange = false
        this.isConditionHide = true
      }
    },
    onClearButtonClick: function () {
      this.isCreateStickyHeader = false
      this.$emit('clear')
    },
    onRemoveConditionClick: function (itemNm) {
      this.isCreateStickyHeader = false
      this.isConditionChange = true
      this.$emit('removeCondition', itemNm)
    },
    onCsvButtonClick: function () {
      this.isCsvDownloader = true

      this.csvConditions.APIReceiveCsvLayoutKbn = this.APIReceiveCsvLayoutKbn
      this.HttpClient
        .post(this.csvFunction, this.csvConditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvdownload')
          this.isCsvDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = this.csvFileName + '_' + ts + '.csv'
          elem.click()
        })
    },
    onXlsButtonClick: function () {
      this.isXlsDownloader = true
      this.xlsConditions.APIReceiveCsvLayoutKbn = this.APIReceiveCsvLayoutKbn
      this.HttpClient
        .requestFileByPost(this.xlsFunction, this.xlsConditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = this.xlsFileName + '_' + ts + '.xlsx'
          elem.click()
        })
    },
    // データテーブル操作
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      this.$emit('dblclick', e, f)
    },
    onRowEditButtonClick: function (e) {
      console.log('onRowEditButtonClick', e)
      this.$emit('edit', e)
    },
    onRowDetailButtonClick: function (e) {
      console.log('onRowDetailButtonClick', e)
      this.$emit('detail', e)
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      const self = this
      this.vitemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        self.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        self.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      const self = this
      this.vPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        self.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        self.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },

    getItemName: function (item) {
      if (item.type === 'checkbox') {
        console.log(item.name, this.conditions[item.key])
        return this.conditions[item.key] === true ? item.name : ''
      } else {
        return item.name + (item.showValue ? '：' : '')
      }
    },
    getItemValue: function (item) {
      console.log('getItemValue', this.conditions, item)
      if (!item.showValue) return ''

      if (item.convertValue === true) {
        return this.getItemValueFromMasterData(item)
      } else {
        if ([undefined, null].includes(item.value)) return ''

        const dotIndex = item.value.indexOf('.')
        if (dotIndex > 0) {
          const itemArray = item.value.split('.')
          console.log(this.conditions[itemArray[0]][itemArray[1]])
          return this.conditions[itemArray[0]][itemArray[1]]
        } else {
          return this.conditions[item.value]
        }
      }
    },
    getItemValueFromMasterData: function (item) {
      var rtnVal = ''
      const self = this
      if (item.master === 'mstshubetsu') {
        const m = self.shubetsuList.filter((elem) => {
          return elem.kaishaCd === self.currentKaishaCode && elem.sbtShuruiCd === item.kbnShuruiCd && elem.sbtCd === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].sbtNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msyskubun') {
        const m = self.kubunList.filter((elem) => {
          return elem.kaishaCd === self.currentKaishaCode && elem.kbnShuruiCd === item.kbnShuruiCd && elem.code === self.conditions[item.key]
        })
        if (m.length > 0) {
          rtnVal = m[0].codeNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msteigyosho') {
        const m = self.eigyoshoList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.eigyoshoCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].eigyoshoNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msttorihikisaki') {
        const m = self.torihikisakiList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.torihikisakiCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].torihikisakiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstsharyo') {
        const m = self.sharyoList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.sharyoCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].jidoshaHyojiNm
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'mstjinin') {
        const m = self.jininList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.jininCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].jininNmSei
        } else {
          rtnVal = ''
        }
      } else if (item.master === 'msthacchakuchi') {
        const m = self.hacchakuchiList.filter((elem) => {
          return (item.key.slice(-2) === 'Id' && elem.id === self.conditions[item.key]) ||
                  (item.key.slice(-2) === 'Cd' && elem.hacchakuchiCd === self.conditions[item.key])
        })
        if (m.length > 0) {
          rtnVal = m[0].hacchakuchNm
        } else {
          rtnVal = ''
        }
      }
      return rtnVal
    },
    getRowKey (row, rowIndex) {
      // itemKey が指定されていて、row にそのプロパティがあればそれを使う
      if (this.itemKey && row && row[this.itemKey] !== undefined && row[this.itemKey] !== null) {
        return row[this.itemKey]
      }
      // 無ければ index
      return rowIndex
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
</script>
<style scoped>
.filter-row-text {
  margin-left: 4px;
  margin-right: 4px;
  color: green;
}
/* データテーブルのsticky制御用 */
::v-deep .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  padding: 0 5px !important;
}
::v-deep .v-data-table>.v-data-table__wrapper>table>thead>tr>td {
  padding: 0 5px !important;
}
::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>th {
  padding: 0 5px !important;
}
::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 5px !important;
}
::v-deep .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th {
  padding: 0 5px !important;
}
::v-deep .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td {
  padding: 0 5px !important;
}
.dt-area {
  contain: paint;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: visible !important;
}
::v-deep .v-data-table__wrapper {
  overflow-x: hidden !important;
  overflow-y: visible !important;
}
::v-deep .v-data-table--fixed-header thead {
  position: sticky !important;
  position: -webkit-sticky !important;
  top: 0px !important;
  z-index: 9 !important;
}
.sticky-scroll {
  position: sticky !important;
  position: -webkit-sticky !important;
  top: 32px !important;
  left: 0px !important;
  z-index: 10 !important;

  height:14px !important;
  padding:0 !important;
}
.scroll-x-bar {
  overflow-y: hidden;
  overflow-x: scroll;
  width: var(--div-width);
  height: 14px;

  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0px !important;
}
.sticky-hidden{
  position: sticky !important;
  position: -webkit-sticky !important;
  top: 58px !important;
  z-index: 10 !important;
}
.sticky-hidden-header {
  overflow-x: auto;

  /* レイアウト設定 App.cssより*/
  font-size: 0.75rem;
  font-weight: bold;
  white-space : nowrap !important;
  padding: 0 5px;
  background: #E3E3E3 0% 0% no-repeat padding-box !important;
  border-top: thin solid rgba(0,0,0,.12) !important;
  box-shadow: inset 0 -1px 0 rgba(0,0,0,.12) !important;
}
.sticky-hidden-div {
  overflow: hidden !important;
  width: var(--div-width);

  height: 30px;
  font-size: 0.75rem;
  font-weight: bold;
  white-space : nowrap !important;
  color: #1F2B38;
  background: #efeff5 0% 0% no-repeat padding-box !important;
  box-shadow: inset 0 -1px 0 rgba(0,0,0,.12) !important;
}
::v-deep .sticky-hidden-div-span {
  padding: 4px 5px !important;
  border: thin solid #f0f0f0 !important;
  color: #1F2B38;
  background: #efeff5 0% 0% no-repeat padding-box !important;
  height: 30px;
}
.sticky-hidden-scroll {
  position: sticky !important;
  position: -webkit-sticky !important;
  top: 32px !important;
  left: 0px !important;
  z-index: 90 !important;

  height:14px !important;
  padding:0 !important;
}
.inner-topbar {
  width: var(--table-width);
  height: 2px;
}
/* App.css更新 */
tbody {
    overflow-x:hidden !important;
    display:block !important;
    width:100%;
}
/**
 * 先頭列のみSticky設定
 * ※2列目以降は独自記述する事
 */
 ::v-deep .span-sticky-col1 {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 9 !important;
}
::v-deep .v-data-table.v-data-table--fixed-header thead th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 4 !important;
}
::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  background: white;
  z-index: 3 !important;
}
</style>
